import React from "react";
import { Pagination, Button } from "zina-dogi-react";
import { Link } from "react-router-dom";
import { utils } from "~/utils";
import { service as voaService } from "../redux";
import swal from "sweetalert";

const titles = ["VOA Number", "Vendor Code", "Vendor Name", "Document Date", "Validity Period End"];

const VoaTable = ({ list, pagination, ...props }) => {
    const { className } = props;
    const voaTable_op = {
        className: ["voa_table", className].join(" ")
    };
    return (
        <div {...voaTable_op}>
            <nav className="navbar">
                <span className="navbar-brand h4" />
                <div className="voa_links controls">
                    <Button
                        color="primary"
                        className="ml-1 mr-1"
                        onClick={() => {
                            voaService.requestSummaryReport().then(data => {
                                if (data && data.detail) {
                                    swal({
                                        title: "Successfully!",
                                        text: data.detail,
                                        icon: "success",
                                        timer: 3000,
                                        button: true
                                    });
                                }
                            });
                        }}
                    >
                        VOA vendor summary report
                    </Button>
                    <Button
                        color="primary"
                        className="ml-1 mr-1"
                        onClick={() => {
                            voaService.requestReport().then(data => {
                                if (data && data.detail) {
                                    swal({
                                        title: "Successfully!",
                                        text: data.detail,
                                        icon: "success",
                                        timer: 3000,
                                        button: true
                                    });
                                }
                            });
                        }}
                    >
                        VOA report
                    </Button>
                    <Link to="/voa/sumary/importer" className="btn-success btn zina-btn ml-1 mr-1">
                        VOA summary importer
                    </Link>
                    <Link to="/voa/importer" className="btn-success btn zina-btn ml-1 mr-1">
                        Add or edit VOA
                    </Link>
                    <Link to="/voa/voa-case/importer" className="btn-success btn zina-btn ml-1 mr-1">
                        Add or edit VOA case
                    </Link>
                </div>
            </nav>
            <br />
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`cpo_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(list)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = list => {
    const values = Object.values(list);
    if (values.length > 0) {
        return values.map((voa, i) => {
            return (
                <tr key={`voa_${i}`} style={{ textAlign: "center" }}>
                    <td>
                        <Link to={`/voa/detail/${voa.id}`}>{voa.voa_number}</Link>
                    </td>
                    <td>{voa.vendor.vendor_number}</td>
                    <td>{voa.vendor.legal_name}</td>
                    <td>{utils.renderDate(voa.document_date)}</td>
                    <td>{utils.renderDate(voa.validity_period_end)}</td>
                </tr>
            );
        });
    } else {
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    }
};

export default VoaTable;
